<template>
  <div ref="pageRoot" style="overflow: auto;" @scroll="onScroll">
    <navBox type="list" :pagetype="this.pageType" />
    <div v-if="this.pageType == 'search'" class='searchrootBox'>
      <div class="searchBox">
          <input type="text" placeholder="请输入用户ID" id="search" v-model="strSearchKeyData"  @keypress.enter='onSearch'>
          <div class="searchBtn" @click="onSearch"></div>
      </div>
      <div class="anchorListCon" ref='listRoot'>
          <div :class='this.searchResultlList.length <= 0 ? "searchNoResult" : "searchResult"'>
            {{this.searchResultText}}
          </div>
          <ul v-if="this.searchResultlList.length > 0">
            <anchorListItem v-for="(item,index) in searchResultlList" :itemData="item" :key="index" @onClickHotListAnchor="onClickAnchor" :bSimple='true'></anchorListItem>
          </ul>
          <div class="clearfloat"></div>
          <!-- <div class="clearfloat loadMore" @click="loadMore">加载更多</div> -->
        </div>
    </div>
    <div v-if="anchorList.length > 0" class="listPage" :style="this.pageType == 'search' && this.searchResultlList.length > 0 ? unDisplay:display">
      <div class="slideNav">
        <div class="listViewTitle">
          <div class="listViewTitleCon">
            <div  v-if="this.pageType == 'hot'" style="display:flex">
              <div class="listViewTitleHotIcon"></div>
              <p>热门主播</p>
            </div>
            <div  v-else-if="this.pageType == 'new'" style="display:flex">
              <div class="listViewTitleNewIcon"></div>
              <p>最新主播</p>
            </div>
            <div style="display:flex" v-else-if="this.pageType == 'attention'">
              <div class="listViewTitleFavoriteIcon"></div>
              <p>关注主播</p>
            </div>
            <div style="display:flex" v-else-if="this.pageType == 'search'">
              <div class="listViewTitleHotIcon"></div>
              <p>猜你喜欢</p>
            </div>
          </div>
        </div>
        <div class="anchorListCon" ref='listRoot'>
          <ul v-if="this.pageType == 'new'">
            <anchorListItem v-for="(item,index) in anchorList" :itemData="item" :key="index" @onClickHotListAnchor="onClickAnchor"></anchorListItem>
          </ul>
          <ul v-else-if="this.pageType == 'hot'">
            <anchorListItem v-for="(item,index) in anchorList" :itemData="item" :key="index" @onClickHotListAnchor="onClickAnchor"></anchorListItem>
          </ul>
          <ul v-else-if="this.pageType == 'attention'">
            <anchorListItem v-for="(item,index) in anchorList" :itemData="item" :key="index" @onClickHotListAnchor="onClickAnchor"></anchorListItem>
          </ul>
          <ul v-else-if="this.pageType == 'search' && this.searchResultlList.length <= 0">
            <anchorListItem v-for="(item,index) in anchorList" :itemData="item" :key="index" @onClickHotListAnchor="onClickAnchor"></anchorListItem>
          </ul>
          <div class="clearfloat"></div>
          <div v-if="(this.pageType == 'new' || this.pageType == 'hot') && bCanLoadMore" class="clearfloat loadMore" @click="loadMore">加载更多</div>
        </div>
      </div>
    </div>
    <div v-else-if="this.pageType != 'search'" class='noAnchorFrame'>
      <div class='noAnchorIcon' ></div>
      {{this.noAnchorString}}
    </div>
    <footerBox />
  </div>
</template>
<script>
import navBox from "@/components/navbox";
import anchorListItem from "@/components/anchorCard/anchorListItem";
import footerBox from "@/components/footer";
import crypt from '@/js/utils/crypt.js';
import jsonpAdapter from 'axios-jsonp'
export default {
  name: "listPage",
  beforeCreate(){
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      location.replace('https://wt.sinashow.com/findex.html');
    }
  },
  mounted() {
    // if(this.pageType == 'new') {
    //   this.getNewList(1, 4);
    // } else if(this.pageType == 'hot') {
    //   this.getHotList(1, 4);
    // } else if(this.pageType == 'attention') {
    //     this.getAttentionList();
    // } else if(this.pageType == 'search'){
    //   this.getHotList(1, 2);
    //   this.$store.commit('SEARCH_RESULT_UPDATE_ANCHORLIST',null);
    //   this.searchUser(this.$store.state.searchResult.Page);
    // }
    let that = this;
    window.addEventListener("scroll", function(e, a) {
   	//变量scrollTop是滚动条滚动时，距离顶部的距离
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
   	//变量windowHeight是可视区的高度
   	let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
   	//变量scrollHeight是滚动条的总高度
   	let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if ( scrollTop+windowHeight >= scrollHeight ) {
        that.loadMore()
      }
    });
  },
  data(){
    return{
      strSearchKeyData:"",
      strSearchResultTextData:"",
      strPageTypeData:"",
      bCanLoadMore:true,
    };
  },
  components: { navBox, anchorListItem, footerBox },
  methods:{
    onClickAnchor(uid){
      let strPath = "/live/"+uid;
      let param = { path: strPath };
      this.$router.push(param);
    },
    onScroll(e, a) {

    },
    onSearch(){
      this.$store.commit('SEARCH_RESULT_UPDATE_KEY', this.strSearchKeyData);
    },
    getSign(user_id, version, time, token, page, reg_mac, key) {
        let t = "{0}{1}{2}{3}{4}{5}{6}";
        return crypt.getMD5(t.format(user_id, version, time, token, page, reg_mac, key));
    },
    getHotList(iPage, maxPage){
      this.bCanLoadMore = true;
      let that = this;
      let nowtimeStamp = new Date().getTime();
      let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, iPage, localStorage.getItem('mac'), 'get_hot_list_h5');
      let data = {
              page:iPage,
              qid: this.$store.state.loginUserInfo.qid,
              reg_mac: localStorage.getItem('mac'),
              token: this.userToken,
              user_id: this.userInfo.user_id,
              time: nowtimeStamp,
              ver: this.$store.state.loginUserInfo.version,
              version:this.$store.state.loginUserInfo.version,
              pid: this.$store.state.loginUserInfo.pid,
              uid: this.userInfo.user_id,
              source:'live',
              type:'0',
              sign:sign,
          }
        this.axios.jsonp("https://external.fengbolive.com/cgi-bin/get_hot_list_h5.fcgi?"+this.$common.changeobj(data)).then(res=>{
          let data = res;
          if (data.code >= 0 || data.ret >= 0) {
            data['page'] = iPage;
            if(iPage == 1){
              that.$store.dispatch('upDataAnchorListData',null);
            }
            if (data.info != null)
            {
              that.$store.dispatch('upDataAnchorListData',data);
            } else {
              that.bCanLoadMore = false;
            }
            if(maxPage && iPage < maxPage){
              that.getHotList(iPage+1, maxPage);
            }
          }else{
            this.bCanLoadMore = false;
          }
        });
    },
    getNewList(iPage, maxPage){
      this.bCanLoadMore = true;
      let that = this;
      let nowtimeStamp = new Date().getTime();
      let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, iPage, localStorage.getItem('mac'), 'sbj09th21sj63kj58ry37');
      let data = {
          page:iPage,
          qid: this.$store.state.loginUserInfo.qid,
          reg_mac: localStorage.getItem('mac'),
          sign:sign,
          token: this.userToken,
          user_id: this.userInfo.user_id,
          ver: this.$store.state.loginUserInfo.version,
          time: nowtimeStamp,
          pid: this.$store.state.loginUserInfo.pid,
          uid: this.userInfo.user_id,
          version:this.$store.state.loginUserInfo.version,
          source:'live',
          type:'0'
        }
        console.log("new");
        console.log("https://external.fengbolive.com/cgi-bin/get_new_anchor_list.fcgi?" + this.$common.changeobj(data))

        this.axios.jsonp("https://external.fengbolive.com/cgi-bin/get_new_anchor_list.fcgi?"+this.$common.changeobj(data)).then(res=>{
          let data = res;
          if (data.code >= 0 || data.ret >= 0) {
            data['page'] = iPage;
            if(iPage == 1){
              that.$store.dispatch('upDataAnchorListData',null);
            }
            if (data.info != null)
            {
              that.$store.dispatch('upDataAnchorListData',data);
            }
            if(iPage < data.pages && maxPage && iPage < maxPage){
              that.getNewList(iPage+1, maxPage);
            }
          }else{
            this.bCanLoadMore = false;
          }
        });
      },
      getAttentionList(){
        var nowtimeStamp = new Date().getTime();

        let t = "{0}{1}{2}{3}{4}{5}";
        let sign = crypt.getMD5(t.format(this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, 'follow_list',localStorage.getItem('mac')));
        let data = {
          isJump: 1,
          uid: this.userInfo.user_id,
          token: this.userToken,
          version: this.$store.state.loginUserInfo.version,
          reg_mac: localStorage.getItem('mac'),
          pid: this.$store.state.loginUserInfo.pid,
          timestamp: nowtimeStamp,
          sign: sign
        };
        console.log("new");
        console.log("https://external.fengbolive.com/cgi-bin/follow_list.fcgi?" + this.$common.changeobj(data))
        let that = this;
        this.axios.jsonp("https://external.fengbolive.com/cgi-bin/follow_list.fcgi?"+this.$common.changeobj(data)).then(res=>{
          let data = res;
          if (data.code >= 0 || data.ret >= 0) {
            data['page'] = 0;
            that.$store.dispatch('upDataAnchorListData',null);
            if (data.info != null)
            {
              that.$store.dispatch('upDataAnchorListData',data);
            }
          }
        });
      },
    searchUser(ipage){
      let that = this;
      if (this.$store.state.searchResult.key == '') {
        this.strSearchResultTextData = '';
      }
      if ((ipage-1)*this.$store.state.searchResult.countPerPage >= this.$store.state.searchResult.totaleCount || this.$store.state.searchResult.key == '') {
        return;
      }
      let data = {
          key: encodeURIComponent(this.$store.state.searchResult.key),
          pid: this.$store.state.loginUserInfo.pid,
          uid: this.userInfo.user_id,
          max: this.$store.state.searchResult.countPerPage,
          skip: (ipage-1)*this.$store.state.searchResult.countPerPage,
          type: 1,
        }
        //console.log("search");
        //console.log("https://external.fengbolive.com/cgi-bin/search_user.fcgi?" + this.$common.changeobj(data))
        this.axios.jsonp("https://external.fengbolive.com/cgi-bin/search_user.fcgi?" + this.$common.changeobj(data)).then(res=>{
          let data = res;
          if (data.result) {
            if (ipage == 1) {
              that.$store.dispatch('upDataSearchResultListData',null);
            }

            if (data.list != null && data.total_count > 0)
            {
              that.$store.commit('SEARCH_RESULT_UPDATE_TOTLE',data.total_count);
              that.$store.dispatch('upDataSearchResultListData',data);
              that.$store.dispatch('upDataSearchResultPage',ipage);
              that.strSearchResultTextData = "找到" + data.total_count +"条关于“"+ that.$store.state.searchResult.key + "”的搜索结果";
            }else{
              that.strSearchResultTextData = "抱歉，没有找到“" +  that.$store.state.searchResult.key + "”相关内容";
            }
          }
        });
      },
      loadMore(){
        if (this.bCanLoadMore) {
          let iPage = this.$store.state.anchorListData.currentPage;
          if (this.pageType == 'new') {
            this.getNewList(iPage+1, iPage+2);
          }else if(this.pageType == 'hot'){
            this.getHotList(iPage+1, iPage+2);
          }else if(this.pageType == 'search'){
            this.searchUser(this.$store.state.searchResult.Page+1);
          }
        }
      }
  },

  computed:{
    anchorList(){
      return this.$store.state.anchorListData.anchorList;
    },
    pageType(){
      this.strPageTypeData = this.$route.query.type;
      return this.$route.query.type;
    },
    userInfo(){
      if(this.$store.state.loginUserInfo.info){
          return this.$store.state.loginUserInfo.info
      }else{
          return JSON.parse(sessionStorage.getItem('userInfo'));
      }
    },
    userToken(){
      if(this.$store.state.loginUserInfo.token){
          return this.$store.state.loginUserInfo.token
      }else{
          return sessionStorage.getItem('token');
      }
    },
    searchResultlList(){
      return this.$store.state.searchResult.resultList;
    },
    searchKey(){
      this.strSearchKeyData = this.$store.state.searchResult.key
      return this.$store.state.searchResult.key;
    },
    searchResultText(){
      if (this.strSearchResultTextData == '') {
        return '请输入用户ID';
      }else{
        return this.strSearchResultTextData;
      }
    },
    display(){
      return {
        display:'block'
      }
    },
    unDisplay(){
      return {
        display:'none'
      }
    },
    noAnchorString(){
      if (this.pageType == 'attention') {
        return '您的关注空空如也，快去加满吧~';
      }else if (this.pageType == 'hot' || this.pageType == 'new') {
        return '主播马上就位，先看看其他主播吧~';
      }
    }
  },
  watch:{
    strPageTypeData(newValue, oldValue) {
      if (newValue == 'new') {
        this.getNewList(1, 4);
      } else if(newValue == 'hot') {
        this.getHotList(1, 4);
      } else if(newValue == 'attention') {
        this.getAttentionList();
      }else if(newValue == 'search'){
        this.getHotList(1, 2);
        this.$store.commit('SEARCH_RESULT_UPDATE_ANCHORLIST',null);
        this.searchUser(this.$store.state.searchResult.Page);
      }
    },
    searchKey(newValue, oldValue){
        this.$store.commit('SEARCH_RESULT_UPDATE_ANCHORLIST',null);
        this.searchUser(this.$store.state.searchResult.Page);
    }
  }
};
</script>
<style scoped>
.clearfloat{clear:both;height:0px;font-size:0px;line-height:0px;} 
.loadMore{cursor: pointer; margin:10px auto 0px auto ;height:30px; width:1024px; font-size:13px; text-align: center; line-height:30px;color: rgb(201, 201, 201); border-color: rgb(201, 201, 201); border-style: solid;border-width: 1px; border-radius: 15px;}
.loadMore:hover{color: #7c46e8; border-color: #7c46e8;}
</style>

<style>
.listPage{  
  min-width: 1200px;
  max-width: 1340px;
  margin: 0 auto;
  height:auto!important;
  height:400px;
  min-height:400px;
  padding: 0px 50px 0px 50px;
  margin-bottom: 50px;
}

.slideNav{
  height: 100%;
}
.searchrootBox .anchorListCon,
.slideNav .anchorListCon {
  height: 100%;
}
.searchrootBox .anchorListCon li,
.slideNav .anchorListCon li {
  width: 195px;
  height: 195px;
  position: relative;
  float: left;
  overflow: hidden;
  margin-left: 12px;
  margin-top: 10px;

}
 /* .searchrootBox .anchorListCon li:nth-child(1),
.slideNav .anchorListCon li:nth-child(1) {
  margin-left: 0px;
}  */

.searchrootBox .anchorListCon li:hover .liverRoomInfo,
.slideNav .anchorListCon li:hover .liverRoomInfo {
  opacity: 0;
}

.searchrootBox .anchorListCon li:hover .liverMask,
.slideNav .anchorListCon li:hover .liverMask {
  opacity: 1;
}

.searchrootBox .anchorListCon .liverRoomInfo,
.slideNav .anchorListCon .liverRoomInfo {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 5px;
  transition: opacity 0.2s;
}
.searchrootBox .anchorListCon .liverRoomInfo .peoNum,
.slideNav .anchorListCon .liverRoomInfo .peoNum {
  display: flex;
  justify-content: space-around;
}
.searchrootBox .anchorListCon .liverRoomInfo .liverAdd,
.slideNav .anchorListCon .liverRoomInfo .liverAdd {
  margin-right: 20px;
}

.searchrootBox .anchorListCon .liverMask,
.slideNav .anchorListCon .liverMask {
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 18px;
  opacity: 0;
  transition: opacity 0.8s;
}
.mousecursor  {
  cursor :pointer;
}

.slideNav .listViewTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  margin-top: 15px;
}
.slideNav .listViewTitleCon {
  display: flex;
  justify-content: flex-start;
  font-size: 20px;
  align-items: center;
  color: #333;
}
.slideNav .listViewTitleHotIcon {
  background: url("~@/assets/images/hot_ico.png");
  background-size: 24px 24px;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-left: 10px;
}

.slideNav .listViewTitleNewIcon {
  background: url("~@/assets/images/new_icon.png");
  background-size: 24px 24px;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-left: 10px;
}

.slideNav .listViewTitleFavoriteIcon {
  background: url("~@/assets/images/collection_icon.png");
  background-size: 24px 24px;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-left: 10px;
}

</style>
<style scoped>
.searchrootBox{
    max-width: 1340px;
    min-width: 1200px;
    margin: 0 auto;
    height: auto!important;
    height: 400px;
    min-height: 400px;
    padding: 0px 50px 0px 50px;
    margin-bottom: 50px;
}
.searchBox{ width: 600px; height: 44px; border: 2px #5a24c6 solid; border-radius: 22px; box-sizing: border-box; overflow: hidden; position: relative; margin: 49px auto 0px auto;}
.searchBox #search{ width: 100%; height: 100%; padding:0 65px 0 12px; box-sizing: border-box; line-height: 30px; font-size: 20px; color: #333333}
.searchBox .searchBtn{ position: absolute; width: 65px; height: 40px; background: url("~@/assets/images/searchIcon_white.png") center center no-repeat; background-color: #7c46e8; right: 0px; top: 0px; cursor: pointer;}
.searchNoResult{
  margin: 120px auto 0px auto;
  height: 30px;
  text-align:center;
  font-size: 24px;
  color: #999999;
}
.searchResult{
  margin: 60px auto 60px auto;
  height: 30px;
  text-align:center;
  font-size: 24px;
  color: #333333;
}
.noAnchorFrame{
  margin: 237px auto 180px auto;
  text-align:center;
  color: #999999;
}
.noAnchorIcon{
  margin: 0px auto 37px auto;
  background: url(~@/assets/images/noAnchorbkg.png);
  height: 111px;
  width: 119px;
}
</style>

